import { useEffect, useRef } from "react";
import "./SidebarAds.css";

const SidebarAds = () => {
  const ad1 = useRef(null);
  const ad2 = useRef(null);

  useEffect(() => {
    try {
      if (ad1.current && !ad1.current.getAttribute("data-adsbygoogle-status")) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }

      if (ad2.current && !ad2.current.getAttribute("data-adsbygoogle-status")) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  return (
    <div className="sidebar-ad-container">

      {/* 300x600 Display Ad */}
      <ins
        ref={ad1}
        className="adsbygoogle"
        style={{
          display: "inline-block",
          width: "300px",
          height: "600px",
        }}
        data-ad-client="ca-pub-5162535306990850"
        data-ad-slot="YOUR_300x600_SLOT_ID"
      ></ins>

      <div style={{ height: 25 }} />

      {/* Auto Relaxed Ad */}
      <ins
        ref={ad2}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-5162535306990850"
        data-ad-slot="9748200331"
        data-ad-format="autorelaxed"
      ></ins>

    </div>
  );
};

export default SidebarAds;